export const rankingCards = [
  {
    id: 'mitsui',
    name: '三井住友カード（NL）',
    logo: 'https://www.smbc-card.com/camp/numberless/index3/img/card_nl_gr.png',
    returnRate: '0.5%～最大7%',
    annualFee: '永年無料',
    benefits: [
      '対象のコンビニ・飲食店でスマホのタッチ決済利用時、最大7%ポイント還元',
      '年会費永年無料で維持コストゼロ',
      '新規入会＆利用で最大25,600円相当のVポイントプレゼント'
    ],
    mainBenefit: '新規入会特典最大25,600円相当＋コンビニ最大7%還元',
    officialUrl: 'https://www.smbc-card.com/camp/numberless/affiliate_index.jsp',
    detailUrl: '/mitsui'
  },
  {
    id: 'rakuten',
    name: '大手ECモール系カード',
    logo: 'https://image.card.jp.rakuten-static.com/card_corp/card_rakuten/campaign/rakuten_card/zentai/2026/0126/merit_card-silver.png',
    returnRate: '1.0%～3.0%',
    annualFee: '永年無料',
    benefits: [
      '100円につき1ポイント貯まる（基本還元率1.0%）',
      '大手ECモールでのお買い物でポイント+2倍（最大3%還元）',
      '新規入会&利用で最大8,000ポイント進呈'
    ],
    mainBenefit: '大手ECモールで最大3%還元',
    officialUrl: 'https://www.rakuten-card.co.jp/campaign/rakuten_card/affiliate/a.html',
    detailUrl: '/ec-mall-card'
  },
  {
    id: 'dcard',
    name: 'dカード GOLD U',
    logo: 'https://dcard.docomo.ne.jp/std/campaigns/1cm/golduaff-newpro/images/overview_img_basic.png',
    returnRate: '1.0%～11%',
    annualFee: '3,300円（条件達成で実質無料）',
    benefits: [
      '29歳以下限定の若者ファーストゴールドカード',
      'ドコモ料金5%還元、ポイ活MAXで最大11%還元',
      'ahamo利用で毎月+5GB、ケータイ補償3年間最大10万円'
    ],
    mainBenefit: '29歳以下限定・条件達成で年会費実質無料',
    officialUrl: 'https://dcard.docomo.ne.jp/dsw/application?kind=newgold',
    detailUrl: '/dcard'
  },
  {
    id: 'suruga',
    name: '地方銀行系スピード発行カード（一般カード）',
    logo: 'https://www.suruga-card.co.jp/lp/jcb_supihatsu/apply/images/img_lineup_01.png',
    returnRate: '0.5%（優待店で2〜20倍）',
    annualFee: '初年度無料（2年目以降1,375円・条件付き無料）',
    benefits: [
      '最短5分でカード番号発行「スピード発番」対応',
      'スマートフォン保険付帯（年間最高3万円）',
      '国内・海外旅行傷害保険 最高3,000万円'
    ],
    mainBenefit: '最短5分でカード番号発行',
    officialUrl: 'https://www.suruga-card.co.jp/lp/jcb_supihatsu/index.html',
    detailUrl: '/suruga'
  },
  {
    id: 'jaccs',
    name: 'ジャックス Gold Time',
    logo: 'https://www.jaccs.co.jp/goldtime_lp6/images/mv_card01.png',
    returnRate: '1.0%～2.0%',
    annualFee: '初年度無料（年5回利用で翌年も無料）',
    benefits: [
      '200円で2ポイント（通常の2倍）、外食・分割払いで4ポイント',
      '空港ラウンジ無料＆海外・国内旅行保険 最高3,000万円',
      'ポイント自動値引きでサブスク料金もおトクに'
    ],
    mainBenefit: 'ポイント自動値引き＆空港ラウンジ無料',
    officialUrl: 'https://www.jaccs.co.jp/goldtime_lp6/',
    detailUrl: '/jaccs'
  },
  {
    id: 'nexus',
    name: 'デポジット型クレジットカード',
    logo: 'https://apply.mycredit.nexuscard.co.jp/lp/images/img_jtrustcard_b.png',
    returnRate: '0.5%',
    annualFee: '1,375円（税込）※発行手数料1,100円',
    benefits: [
      'デポジット型で審査が不安な方も作りやすい',
      'デポジット5万円〜200万円で利用限度額を自分で決められる',
      'ETCカード発行可能（年会費・発行費無料）※条件あり'
    ],
    mainBenefit: 'デポジット型で審査が柔軟',
    officialUrl: 'https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE',
    detailUrl: '/nexus'
  },
  {
    id: 'ja',
    name: '農協系カード',
    logo: 'https://static.readdy.ai/image/311e6225eef23b4f6720d1b48eefeefb/f39d0f94e601d8134903c1ee38702126.png',
    returnRate: '0.5%（農協グループ店舗で+2%）',
    annualFee: '初年度無料（2年目以降1,375円・条件付き無料）',
    benefits: [
      '農協直売所・ファーマーズマーケットでいつでも5%割引',
      '農協系ガソリンスタンドで1Lにつき2円割引',
      '農協グループ店舗で+2%ポイント還元'
    ],
    mainBenefit: '農協直売所で5%割引＆ガソリン2円引き',
    officialUrl: 'https://www.ad.jacard.cr.mufg.jp/af/?utm_source=affiliate&utm_medium=A8',
    detailUrl: '/ja'
  },
  {
    id: 'recruit',
    name: '高還元率カード',
    logo: 'https://static.readdy.ai/image/311e6225eef23b4f6720d1b48eefeefb/905cd32954f662418f5fc76ec39e68ad.png',
    returnRate: '1.2%',
    annualFee: '永年無料',
    benefits: [
      '基本還元率1.2%と業界最高水準',
      '予約サイト・グルメサイトで最大4.2%還元',
      '年会費永年無料で高還元率を実現'
    ],
    mainBenefit: '基本還元率1.2%の高還元',
    officialUrl: 'https://recruit-card.jp/',
    detailUrl: '/recruit'
  }
];
